<template>
    <b-container v-if="currentGroup" class="mt-5">
        <b-row>
            <b-col md="10">GROUP DENTAL ENROLLMENT FOR {{currentGroup.name | uppercase}}</b-col>
        </b-row>
        <b-row>
            <b-col md="10">&nbsp;</b-col>
        </b-row>
        <b-form v-show="enrollment.complete === false">
            <b-row v-if="!enrollment.action">
                <b-col md="12">
                    <b-form-group label="Enrollment Action:"
                                  label-for="enrollmentAction"
                                  description="Please choose the action you need to take"
                    >
                        <b-form-select :options="enrollmentOptions" v-model="enrollment.action"></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

            <!--EMPLOYEE INFO-->
            <div v-if="enrollment.action && enrollment.step === 'employee'">
                <b-row>
                    <b-col>
                        <h3 class="mb-1">Employee Information</h3>
                        <hr class="mb-5"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="5">
                        <b-form-group label="First Name:" label-for="firstName">
                            <b-form-input
                                    type="text"
                                    v-model="enrollment.firstName">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="2">
                        <b-form-group label="Middle Initial:" label-for="middleName">
                            <b-form-input
                                    type="text"
                                    v-model="enrollment.middleName"
                                    max-length="1">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="5">
                        <b-form-group label="Last Name:" label-for="lastName">
                            <b-form-input
                                    type="text"
                                    v-model="enrollment.lastName">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6">
                        <b-form-group label="Social Security Number:" label-for="ssn">
                            <b-form-input type="text" v-model="enrollment.ssn"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Gender:" label-for="gender">
                            <b-form-select v-model="enrollment.gender" :options="genderOptions"></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Date of Birth:" label-for="dob">
                            <b-form-input type="date" v-model="enrollment.dob"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <hr class="mt-4 mb-4"/>

                <contact-form :model="enrollment" />


                <hr class="mt-4 mb-4"/>

                <b-row>
                    <b-col md="6">
                        <b-form-group label="Hours Worked Per Week:" label-for="hoursWorked">
                            <b-form-input type="number" v-model="enrollment.hoursWorked"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Date Employed Fulltime:" label-for="date_hired">
                            <b-form-input
                                    id="date_hired"
                                    type="date"
                                    v-model="enrollment.dateHired">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <hr class="mt-4 mb-4"/>

                <b-row v-show="enrollment.planSelection === 'dhmo'">
                    <b-col md="10">
                        <b-form-group id="dhmoidLabel" label="DHMO Provider ID:" label-for="dhmoid">
                            <b-form-input type="text" v-model="enrollment.dhmoId"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row >
                    <b-col md="10">
                        <b-form-group id="dept" label="Group Department:" label-for="dhmoid">
                            <b-form-input type="text" v-model="enrollment.dhmoDept"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                        <b-form-group>
                            <label for="hoursWorked" class="d-block">Other Coverage:</label>
                            <b-form-radio-group :options="otherCoverageOptions" name="otherCoverage" v-model="cov"></b-form-radio-group>
                            <b-form-input
                                    type="text"
                                    placeholder="Enter the carrier's name"
                                    v-model="enrollment.otherCarrier"
                                    v-show="cov === 'Y'" class="mt-3">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>

            <!--DEPENDENTS-->

            <div v-if="enrollment.action && enrollment.step === 'dependents'">
                <b-row>
                    <b-col>
                        <h3 class="mb-1">Dependents</h3>
                        <hr/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                        <b-alert class="card-text" variant="warning" show>
                            Please include all covered dependents. Omitted dependents will be
                            terminated.
                        </b-alert>
                    </b-col>
                </b-row>

                <dependents :dependents="enrollment.children" />
            </div>

            <!--PRODUCTS/PLAN SELECTION-->

            <div v-if="enrollment.action && enrollment.step === 'products'">
                <b-row>
                    <b-col>
                        <h3 class="mb-1">Plan Selections</h3>
                        <hr/>
                    </b-col>
                </b-row>

                <plan-selection :model="enrollment" :group="currentGroup"/>
            </div>

            <!--ERRORS-->
            <b-row v-show="enrollment.errors.length" class="mt-5">
                <b-col md="12">
                    <div class="alert alert-danger">
                        <strong>Please correct the following: </strong>
                        <span v-for="(error, index) in enrollment.errors" v-bind:key="error">{{error}}<span v-if="(index+1) !== enrollment.errors.length">, </span></span>
                    </div>
                </b-col>
            </b-row>
            <hr class="mt-5"/>
            <b-row class="mb-5">
                <b-col cols="6">
                    <b-button variant="secondary" @click="$router.go(-1)">Cancel</b-button>
                </b-col>
                <b-col cols="6" class="text-right">
                    <b-button variant="secondary" @click="prev()" v-if="enrollment.step !== 'employee'">Previous</b-button>
                    <b-button variant="primary" @click="next()" v-if="enrollment.action && enrollment.step !== 'products'">Next</b-button>
                    <b-button variant="primary" @click="saveEnrollment()" v-if="enrollment.step === 'products'">Save Enrollment</b-button>

                </b-col>
            </b-row>
        </b-form>
    </b-container>
</template>

<script>
    import axios from 'axios'
    import config from '@/config/config'
    import {mapGetters, mapActions} from 'vuex'
    import ContactForm from "../../../components/Common/ContactForm";
    import Dependents from "../../../components/Common/Dependents";
    import PlanSelection from "./PlanSelection";

    export default {
        components: {
            PlanSelection,
            Dependents,
            ContactForm},
        name: 'Enrollment',
        props: ['groupcode'],
        data: function () {
            return {
                cov: '',
                disableRelationship: false,
                enrollmentOptions: [
                    {value: null, text: 'Please select an event'},
                    {value: 'new_enrollment', text: 'New Employee'},
                    {value: 'open_enrollment', text: 'Open Enrollment'},
                    {value: 'loss_coverage', text: 'Loss of Other Coverage'},
                    {value: 'loss_coverage', text: 'Marriage'},
                    {value: 'loss_coverage', text: 'Divorce'},
                    {value: 'Death', text: 'Death'},
                    {value: 'cobra_enrollment', text: 'COBRA Enrollment'}
                ],
                otherCoverageOptions: [
                    {value: 'Y', text: 'Yes'},
                    {value: 'N', text: 'No Other Coverage'}
                ],
                genderOptions: [
                    {value: '', text: 'Please Select'},
                    {value: 'F', text: 'Female'},
                    {value: 'M', text: 'Male'}
                ],
                dependentOptions: [
                    {value: 'spouse', text: 'Spouse'},
                    {value: 'child', text: 'Child'}
                ],
                enrollment: {
                    children: [],
                    firstName: '',
                    middleInitial: '',
                    lastName: '',
                    gender: '',
                    ssn: '',
                    dob: '',
                    groupUnderwriter: '',
                    groupCode: this.groupcode,
                    planSelection: {
                        DE: {},
                        DL: {},
                        VL: {},
                        VC: {},
                        VD: {},
                        LA: {},
                        VI: {},
                        WI: {},
                        CI: {},
                        DI: {},
                        LT: {},
                    },
                    tierSelection: '',
                    effectiveDate: '',
                    middleName: '',
                    address: '',
                    address2: '',
                    city: '',
                    stateName: '',
                    zipCode: '',
                    homePhone: '',
                    workPhone: '',
                    dhmoId: '',
                    hoursWorked: '',
                    dateHired: '',
                    otherCarrier: '',
                    complete: false,
                    step: 'employee',
                    errors: []
                }
            }
        },
        methods: {
            ...mapActions(['getGroupData']),
            prev: function () {
                if (this.enrollment.step === 'dependents') this.enrollment.step = 'employee';
                if (this.enrollment.step === 'products') this.enrollment.step = 'dependents';
            },
            next: function () {
                switch (this.enrollment.step) {
                    case 'employee':
                        this.enrollment.errors = []
                        switch (this.enrollment.action) {
                            case 'new_enrollment':
                                if (!this.enrollment.firstName) this.enrollment.errors.push('First Name is Required')
                                if (!this.enrollment.lastName) this.enrollment.errors.push('Last Name is Required')
                                if (!this.enrollment.gender) this.enrollment.errors.push('Gender is Required')
                                if (!this.enrollment.ssn) this.enrollment.errors.push('SSN is Required')
                                if (!this.enrollment.address) this.enrollment.errors.push('Address is Required')
                                if (!this.enrollment.city) this.enrollment.errors.push('City is Required')
                                if (!this.enrollment.stateName) this.enrollment.errors.push('State is Required')
                                if (!this.enrollment.zipCode) this.enrollment.errors.push('Zip Code is Required')
                                if (!this.enrollment.dob) this.enrollment.errors.push('Date of Birth is Required')
                                if (!this.enrollment.hoursWorked) this.enrollment.errors.push('Hours Worked is Required')
                                if (!this.enrollment.dateHired) this.enrollment.errors.push('Hired Date is Required')
                                break
                            case 'open_enrollment':
                                if (!this.enrollment.firstName) this.enrollment.errors.push('First Name is Required')
                                if (!this.enrollment.lastName) this.enrollment.errors.push('Last Name is Required')
                                if (!this.enrollment.gender) this.enrollment.errors.push('Gender is Required')
                                if (!this.enrollment.ssn) this.enrollment.errors.push('SSN is Required')
                                if (!this.enrollment.address) this.enrollment.errors.push('Address is Required')
                                if (!this.enrollment.city) this.enrollment.errors.push('City is Required')
                                if (!this.enrollment.stateName) this.enrollment.errors.push('State is Required')
                                if (!this.enrollment.zipCode) this.enrollment.errors.push('Zip Code is Required')
                                if (!this.enrollment.dob) this.enrollment.errors.push('Date of Birth is Required')
                                if (!this.enrollment.hoursWorked) this.enrollment.errors.push('Hours Worked is Required')
                                if (!this.enrollment.dateHired) this.enrollment.errors.push('Hired Date is Required')
                                break
                            case 'loss_coverage':
                                if (!this.enrollment.firstName) this.enrollment.errors.push('First Name is Required')
                                if (!this.enrollment.lastName) this.enrollment.errors.push('Last Name is Required')
                                if (!this.enrollment.gender) this.enrollment.errors.push('Gender is Required')
                                if (!this.enrollment.ssn) this.enrollment.errors.push('SSN is Required')
                                if (!this.enrollment.address) this.enrollment.errors.push('Address is Required')
                                if (!this.enrollment.city) this.enrollment.errors.push('City is Required')
                                if (!this.enrollment.stateName) this.enrollment.errors.push('State is Required')
                                if (!this.enrollment.zipCode) this.enrollment.errors.push('Zip Code is Required')
                                if (!this.enrollment.dob) this.enrollment.errors.push('Date of Birth is Required')
                                if (!this.enrollment.hoursWorked) this.enrollment.errors.push('Hours Worked is Required')
                                if (!this.enrollment.dateHired) this.enrollment.errors.push('Hired Date is Required')
                                break
                        }

                        if (this.enrollment.errors.length === 0) {
                            this.enrollment.step = 'dependents';
                        }
                        break;
                    case 'dependents':
                        this.enrollment.step = 'products';
                        break;

                    case 'products':
                        // submit?
                        break;
                }
            },

            saveEnrollment: function () {

                if (this.enrollment.errors.length === 0) {
                    axios.post(config.apiUrl() + 'producer/save-enrollment', this.enrollment).then(response => {
                        if (response.data.msg === 'ok') {
                            this.enrollment = {
                                children: [],
                                complete: true,
                                errors: []
                            }
                            this.$router.push({path: '/dashboard/producer/pending-details/' + response.data.id})
                        } else {
                            this.enrollment.errors.push(
                                'An error occurred when saving your enrollment. Please check it and try again.'
                            )
                        }
                    }, err => {
                        this.enrollment.errors.push(
                            'An error occurred when saving your enrollment. Please check it and try again.'
                        )
                    })
                }
            }
        },
        computed: {
            ...mapGetters(['currentGroup']),

            products() {
                return Object.keys(this.currentGroup.products)
            }
        },
        beforeMount() {
            this.getGroupData(this.groupcode)
        }
    }
</script>

<style scoped>

</style>
